import { UniformBufferAlone } from "./UniformBufferAlone";
export class UniformBufferUser {
    constructor(name, size, manager, data) {
        this.destroyed = false;
        this.name = name;
        this._strId = '';
        this._items = new Map();
        this._itemNum = 0;
        this.data = data;
        this._size = size;
        this.manager = manager;
        this.needUpload = false;
        if (manager._useBigBuffer) {
            this.bufferBlock = manager.getBlock(size, this);
            this.offset = this.bufferBlock.offset;
        }
        else
            this.bufferAlone = this._createBufferAlone(size, manager);
    }
    _createBufferAlone(size, manager) {
        return new UniformBufferAlone(size, manager, this);
    }
    updateOver() {
        this.needUpload = false;
    }
    notifyGPUBufferChange() {
        const offset = this.bufferBlock.offset - this.offset;
        this.offset = this.bufferBlock.offset;
        this._items.forEach(item => {
            const tac = UniformBufferUser._typeArray(item.type);
            item.view = new tac(this.bufferBlock.cluster.data, item.view.byteOffset + offset, item.size / tac.BYTES_PER_ELEMENT);
        });
        this.clearGPUBufferBind();
        this.needUpload = true;
    }
    clearGPUBufferBind() { }
    addUniform(id, name, type, offset, align, size, elements, count) {
        if (this._items.has(id))
            return;
        this._items.set(id, this._getUniformItem(name, UniformBufferUser._typeArray(type), type, offset, align, size, elements, count));
        if (this._strId.length > 0)
            this._strId += '|';
        this._strId += id;
        this._itemNum++;
    }
    setUniformData(id, data) {
        const item = this._items.get(id);
        if (item) {
            this.needUpload = true;
            if (item.count == 1) {
                switch (item.type) {
                    case 'int':
                    case 'float':
                        item.view[0] = data;
                        break;
                    case 'vec2':
                        item.view[0] = data.x;
                        item.view[1] = data.y;
                        break;
                    case 'vec3':
                        item.view[0] = data.x;
                        item.view[1] = data.y;
                        item.view[2] = data.z;
                        break;
                    case 'vec4':
                        item.view[0] = data.x;
                        item.view[1] = data.y;
                        item.view[2] = data.z;
                        item.view[3] = data.w;
                        break;
                    case 'mat3':
                        for (let i = 0; i < 3; i++) {
                            item.view[i * 4 + 0] = data.elements[i * 3 + 0];
                            item.view[i * 4 + 1] = data.elements[i * 3 + 1];
                            item.view[i * 4 + 2] = data.elements[i * 3 + 2];
                        }
                        break;
                    case 'mat4':
                        item.view.set(data.elements);
                        break;
                    default:
                        break;
                }
            }
            else {
                const arraySize = item.count * item.elements;
                const alignElements = item.size / item.count / item.view.BYTES_PER_ELEMENT;
                for (let i = 0, j = 0; i < arraySize; i += item.elements, j += alignElements)
                    item.view.set(data.subarray(i, i + item.elements), j);
            }
        }
    }
    setBool(id, data) {
        const item = this._items.get(id);
        if (item) {
            item.view[0] = data ? 1 : 0;
            this.needUpload = true;
        }
    }
    setBoolArray(id, data) {
        const item = this._items.get(id);
        if (item) {
            for (let i = 0, len = Math.min(item.count, data.length); i < len; i++)
                item.view[i] = data[i] ? 1 : 0;
            this.needUpload = true;
        }
    }
    setInt(id, data) {
        const item = this._items.get(id);
        if (item) {
            item.view[0] = data;
            this.needUpload = true;
        }
    }
    setIntArray(id, data) {
        const item = this._items.get(id);
        if (item) {
            for (let i = 0, len = Math.min(item.count, data.length); i < len; i++)
                item.view[i] = data[i];
            this.needUpload = true;
        }
    }
    setFloat(id, data) {
        const item = this._items.get(id);
        if (item) {
            item.view[0] = data;
            this.needUpload = true;
        }
    }
    setFloatArray(id, data) {
        const item = this._items.get(id);
        if (item) {
            for (let i = 0, len = Math.min(item.count, data.length); i < len; i++)
                item.view[i] = data[i];
            this.needUpload = true;
        }
    }
    setVector2(id, data) {
        const item = this._items.get(id);
        if (item) {
            item.view[0] = data.x;
            item.view[1] = data.y;
            this.needUpload = true;
        }
    }
    setVector2Array(id, data) {
        const item = this._items.get(id);
        if (item) {
            for (let i = 0, len = Math.min(item.count, data.length); i < len; i++) {
                item.view[i * 2 + 0] = data[i].x;
                item.view[i * 2 + 1] = data[i].y;
            }
            this.needUpload = true;
        }
    }
    setVector3(id, data) {
        const item = this._items.get(id);
        if (item) {
            item.view[0] = data.x;
            item.view[1] = data.y;
            item.view[2] = data.z;
            this.needUpload = true;
        }
    }
    setVector3Array(id, data) {
        const item = this._items.get(id);
        if (item) {
            for (let i = 0, len = Math.min(item.count, data.length); i < len; i++) {
                item.view[i * 4 + 0] = data[i].x;
                item.view[i * 4 + 1] = data[i].y;
                item.view[i * 4 + 2] = data[i].z;
            }
            this.needUpload = true;
        }
    }
    setVector4(id, data) {
        const item = this._items.get(id);
        if (item) {
            item.view[0] = data.x;
            item.view[1] = data.y;
            item.view[2] = data.z;
            item.view[3] = data.w;
            this.needUpload = true;
        }
    }
    setVector4Array(id, data) {
        const item = this._items.get(id);
        if (item) {
            for (let i = 0, len = Math.min(item.count, data.length); i < len; i++) {
                item.view[i * 4 + 0] = data[i].x;
                item.view[i * 4 + 1] = data[i].y;
                item.view[i * 4 + 2] = data[i].z;
                item.view[i * 4 + 3] = data[i].w;
            }
            this.needUpload = true;
        }
    }
    setMatrix3x3(id, data) {
        const item = this._items.get(id);
        if (item) {
            for (let i = 0; i < 3; i++) {
                item.view[i * 4 + 0] = data.elements[i * 3 + 0];
                item.view[i * 4 + 1] = data.elements[i * 3 + 1];
                item.view[i * 4 + 2] = data.elements[i * 3 + 2];
            }
            this.needUpload = true;
        }
    }
    setMatrix3x3Array(id, data) {
        const item = this._items.get(id);
        if (item) {
            for (let j = 0, len = Math.min(item.count, data.length); j < len; j++) {
                for (let i = 0; i < 3; i++) {
                    item.view[j * 16 + i * 4 + 0] = data[j].elements[i * 3 + 0];
                    item.view[j * 16 + i * 4 + 1] = data[j].elements[i * 3 + 1];
                    item.view[j * 16 + i * 4 + 2] = data[j].elements[i * 3 + 2];
                }
            }
            this.needUpload = true;
        }
    }
    setMatrix4x4(id, data) {
        const item = this._items.get(id);
        if (item) {
            item.view.set(data.elements);
            this.needUpload = true;
        }
    }
    setMatrix4x4Array(id, data) {
        const item = this._items.get(id);
        if (item) {
            for (let i = 0, len = Math.min(item.count, data.length); i < len; i++)
                item.view.set(data[i].elements, i * 16);
            this.needUpload = true;
        }
    }
    setBuffer(id, data) {
        this.setUniformData(id, data);
    }
    getUniform(id) {
        return this._items.get(id);
    }
    hasUniform(id) {
        return this._items.has(id);
    }
    isMe(strId) {
        return this._strId === strId;
    }
    upload() {
        if (this.needUpload) {
            if (this.manager._useBigBuffer)
                this.bufferBlock.needUpload();
            else
                this.bufferAlone.upload();
            this.needUpload = false;
        }
    }
    clear() {
        if (this.manager._useBigBuffer)
            new Uint8Array(this.bufferBlock.cluster.data).fill(0, this.bufferBlock.offset, this.bufferBlock.offset + this.bufferBlock.size);
        else
            new Uint8Array(this.bufferAlone.data).fill(0);
        this._strId = '';
        this._items.clear();
        this._itemNum = 0;
        this.needUpload = false;
    }
    destroy() {
        if (!this.destroyed) {
            if (this.manager._useBigBuffer)
                this.manager.freeBlock(this.bufferBlock);
            else
                this.bufferAlone.destroy();
            this.destroyed = true;
            return true;
        }
        console.warn('UniformBufferUser: object alreay destroyed!');
        return false;
    }
    _getUniformItem(name, tac, type, offset, align, size, elements, count) {
        let view;
        if (this.manager._useBigBuffer)
            view = new tac(this.bufferBlock.cluster.data, this.bufferBlock.offset + offset, size / tac.BYTES_PER_ELEMENT);
        else
            view = new tac(this.bufferAlone.data, offset, size / tac.BYTES_PER_ELEMENT);
        return { name, view, type, align, size, elements, count };
    }
    static _typeArray(type) {
        switch (type) {
            case 'int':
                return Int32Array;
            case 'float':
            case 'vec2':
            case 'vec3':
            case 'vec4':
            case 'mat3':
            case 'mat4':
                return Float32Array;
            default:
                return Float32Array;
        }
    }
}
